import React, {useState} from "react";
import {InfoBox, TooltipContainer, Arrow} from "./styles";
import {ReactComponent as InfoIcon} from "../../assets/icons/tooltip_info.svg"
import {ReactComponent as CloseIcon} from "../../assets/icons/close_icon.svg"

interface TooltipProps {
    text: string
}
export const Tooltip = ({text} : TooltipProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const handleTooltipToggle = () => {
        setIsOpen(!isOpen);
    };

    return <TooltipContainer>
        { !isOpen &&
            <button onClick={handleTooltipToggle}><InfoIcon/></button>
        }
        { isOpen &&
            <InfoBox>
                <Arrow/>
                {text}
                <button onClick={handleTooltipToggle}><CloseIcon/></button>
            </InfoBox>
        }
    </TooltipContainer>
}
